import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import AccountLoanListSF from '../../../components/superUser/loan/AccountLoanListSF'
import LoanCreateModalSF from '../../../components/superUser/loan/LoanCreateModalSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'

const AccountLoanListPageUI = ({ context, account, errorList, loanList, onRefreshClick,
  createLoanMode, onCreateLoanClick, onCancelCreateLoan,
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_feas' backLink='/su/accounts'
    headerText={account && account.accountName} dimension='w768'
    centered={!loanList} account={account} page='loans'
  >
    {
      !loanList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      loanList && loanList.length > 0 &&
      <AccountLoanListSF
        context={context}
        account={account}
        loanList={loanList}
        onRefreshClick={onRefreshClick}
        createLoanMode={createLoanMode}
        onCreateLoanClick={onCreateLoanClick}
        onCancelCreateLoan={onCancelCreateLoan}
      />
    }
    {
      loanList && loanList.length === 0 &&
      <div>
        <span className='g_flex_h g_flex_left'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <IconButtonUI icon='icon-plus' onClick={onCreateLoanClick} />
          <span className='g_m_left_100 g_large'><b>Loans in Account</b></span>
        </span>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No loans yet'
        />
      </div>
    }

    <LoanCreateModalSF context={context}
      onRefreshClick={onRefreshClick}
      createMode={createLoanMode} onCancelCreate={onCancelCreateLoan}
      account={account}
    />

  </SuperUserAccountPageUI>

export default AccountLoanListPageUI
